import React, { useMemo, useState } from 'react';
import { Input } from '@/components/ui/input';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Search } from 'lucide-react';

const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');

export const HelpFaq = ({ sections, prefix }) => {
  const [query, setQuery] = useState('');

  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return sections;
    return sections
      .map((s) => ({ ...s, items: s.items.filter((i) => `${i.q} ${i.a}`.toLowerCase().includes(q)) }))
      .filter((s) => s.items.length > 0);
  }, [query, sections]);

  return (
    <div>
      <div className="relative mb-10">
        <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-[#A8A29E]" />
        <Input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          placeholder="Search help topics..."
          className="pl-12 h-12 bg-white border-[#E7E5E4] rounded-none"
          data-testid={`${prefix}-search-input`}
        />
      </div>
      {filtered.length === 0 && (
        <p className="text-[#78716C]" data-testid={`${prefix}-no-results`}>No help topics match "{query}".</p>
      )}
      <div className="space-y-10">
        {filtered.map((s) => (
          <section key={s.section} data-testid={`${prefix}-section-${slug(s.section)}`}>
            <h2 className="text-base md:text-lg font-serif text-[#9F1239] uppercase tracking-widest mb-3">{s.section}</h2>
            <Accordion type="multiple" className="bg-white border border-[#E7E5E4]">
              {s.items.map((i) => (
                <AccordionItem key={i.q} value={i.q} className="px-5">
                  <AccordionTrigger className="text-left font-medium text-[#1C1917] hover:no-underline" data-testid={`${prefix}-q-${slug(i.q)}`}>
                    {i.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#57534E] leading-relaxed">{i.a}</AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </section>
        ))}
      </div>
    </div>
  );
};
